const baseMentionData = { name: "", slug: "" };
const MentionData = {
  fromJSON(object) {
    const message = { ...baseMentionData };
    message.name = object.name !== void 0 && object.name !== null ? String(object.name) : "";
    message.slug = object.slug !== void 0 && object.slug !== null ? String(object.slug) : "";
    message.id = object.id !== void 0 && object.id !== null ? String(object.id) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.name !== void 0 && (obj.name = message.name);
    message.slug !== void 0 && (obj.slug = message.slug);
    message.id !== void 0 && (obj.id = message.id);
    return obj;
  }
};
export {
  MentionData
};
//# sourceMappingURL=decoration_mention.js.map
